module.exports = __webpack_public_path__ + "static/media/savage-patrick.34c80118.png";